// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItem-cls1__Ba","cls2":"CreateSocialItem-cls2_HLX CreateSocialItem-cls1__Ba"};